export enum MENU_STEPPER {
  CREATE = 0,
  CATEGORIES = 1,
  OWNER_MENU = 2,
  EDIT_CATEGORY = 3,
}

export enum EDIT_SUBJECT {
  ITEM,
  VARIATION,
  MODIFIER,
}
